<template>
  <div>
    <v-app-bar
      color="white"
      app
    >
      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click="drawer = true"
        />
      <v-slide-x-transition>
        <h1 class="logo-font">
          Limoges Massage Therapy
        </h1>
      </v-slide-x-transition>

      <v-spacer />
      <div class="hidden-sm-and-down">
        <v-btn
          text
          class="mr-2"
          @click="$vuetify.goTo('#services');"
          >
          Services
        </v-btn>
         <v-btn
          text
          class="mr-2"
          @click="$vuetify.goTo('#aboutme');"
          >
          About Me
        </v-btn>
         <v-btn
          text
          class="mr-2"
          @click="$vuetify.goTo('#getintouch');"
          >
          Get In Touch
        </v-btn>
        <v-btn
          color="indigo darken-3 white--text"
          href="https://limogesmassagetherapy.janeapp.com"
          rounded
        >
          Book Online
        </v-btn>
      </div>
    </v-app-bar>
    <v-navigation-drawer
      class="hidden-md-and-up"
      v-model="drawer"
      app
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title @click="$vuetify.goTo('#services'); drawer = false;">Services</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title @click="$vuetify.goTo('#aboutme'); drawer = false;">About Me</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title @click="$vuetify.goTo('#getintouch'); drawer = false;">Get In Touch</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-btn
              color="indigo darken-3 white--text"
              href="https://limogesmassagetherapy.janeapp.com"
              rounded
              >
              Book Online
            </v-btn>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
  export default {
    name: 'CoreAppBar',

    data: () => ({
      showLogo: false,
      isScrolling: false,
      drawer: false,
      group: null,
    }),

    methods: {
    },
  }
</script>

<style>
@font-face {
  font-family: MarckScript;
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  src: url("~@/assets/MarckScript-Regular.ttf");
}
.logo-font {
  font-family: MarckScript;
  font-size: 24px;
}
</style>
